import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { STATUS_OPTIONS } from '../../../constants';

/**
 * RuleFilters Component
 *
 * Provides filter controls for team, status, and search
 *
 * @component
 */
const RuleFilters = ({ filters, onFilterChange, onRefresh, hideTeamFilter }) => {

  // Get teams from Redux
  const teams = useSelector(state => state.dataCategorization.teams);

  // Convert teams to dropdown options and add "All Teams"
  const teamOptions = [
    { label: 'All Teams', value: '' },
    ...teams.map(team => ({
      label: team.label,
      value: team.value
    }))
  ];

  const statusOptions = STATUS_OPTIONS;

  return (
    <div className="rule-filters">
      {!hideTeamFilter && (
        <div className="filter-group">
          <label htmlFor="team-filter">Team</label>
          <Dropdown
            id="team-filter"
            value={filters.team}
            options={teamOptions}
            onChange={(e) => onFilterChange({ team: e.value })}
            placeholder="All Teams"
            className="filter-dropdown"
          />
        </div>
      )}

      <div className="filter-group">
        <label htmlFor="status-filter">Status</label>
        <Dropdown
          id="status-filter"
          value={filters.enabled}
          options={statusOptions}
          onChange={(e) => onFilterChange({ enabled: e.value })}
          placeholder="All Status"
          className="filter-dropdown"
        />
      </div>

      <div className="filter-group filter-search">
        <label htmlFor="search-filter">Search</label>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            id="search-filter"
            value={filters.search}
            onChange={(e) => onFilterChange({ search: e.target.value })}
            placeholder="Search by rule name..."
            className="filter-input"
          />
        </span>
      </div>

      <div className="filter-actions">
        <Button
          label="Refresh"
          icon="pi pi-sync"
          className="p-button-outlined p-button-primary"
          onClick={onRefresh}
          tooltip="Refresh rules grid"
        />
      </div>
    </div>
  );
};

RuleFilters.propTypes = {
  filters: PropTypes.shape({
    team: PropTypes.string,
    enabled: PropTypes.bool,
    search: PropTypes.string
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  hideTeamFilter: PropTypes.bool
};

export default RuleFilters;

